import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import SurveyResponsesService from "../service/surveyResponses";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useSurveyResponses(conditions) {
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const surveyResponsesService = new SurveyResponsesService(httpClient);
  const queryClient = useQueryClient();

  const surveyResponsesQuery = useQuery(
    ["surveyResponses", conditions],
    () => surveyResponsesService.findAllSurveyResponses(conditions),
    {
      enabled:
        !!conditions?.schoolid &&
        (!!conditions?.survey_id || !!conditions?.username),
      staleTime: 1000 * 60 * 5, // 5분
      onError: (error) => {
        console.error("설문 응답 조회 오류:", error);
      },
      onSuccess: (data) => {
        console.log("surveyResponses API 성공");
      },
    }
  );

  const createSurveyResponse = useMutation(
    (data) => surveyResponsesService.createSurveyResponse(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyResponses"]);
      },
      onError: (error) => {
        console.error("설문 응답 생성 오류:", error);
      },
    }
  );

  const updateSurveyResponse = useMutation(
    (data) => surveyResponsesService.updateSurveyResponse(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyResponses"]);
      },
      onError: (error) => {
        console.error("설문 응답 수정 오류:", error);
      },
    }
  );

  const createOrUpdateResponse = useMutation(
    (data) => surveyResponsesService.createOrUpdateResponse(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyResponses"]);
      },
      onError: (error) => {
        console.error("설문 응답/답변 저장 오류:", error);
      },
    }
  );

  const cancelSubmission = useMutation(
    (data) => surveyResponsesService.cancelSubmission(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyResponses"]);
      },
      onError: (error) => {
        console.error("제출 취소 오류:", error);
      },
    }
  );

  const checkResponseExists = useMutation(
    (conditions) => surveyResponsesService.checkResponseExists(conditions),
    {
      onError: (error) => {
        console.error("응답 존재 확인 오류:", error);
      },
    }
  );

  const deleteSurveyResponse = useMutation(
    (id) => surveyResponsesService.deleteSurveyResponse(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyResponses"]);
      },
      onError: (error) => {
        console.error("설문 응답 삭제 오류:", error);
      },
    }
  );

  return {
    surveyResponsesQuery,
    createSurveyResponse,
    updateSurveyResponse,
    createOrUpdateResponse,
    cancelSubmission,
    checkResponseExists,
    deleteSurveyResponse,
  };
}
